import React from "react";
import "../css/style.css";

import { CircularProgress } from "@material-ui/core";
import i18next from "i18next";
import { connect } from "react-redux";
import {
  CartesianGrid,
  Legend,
  Line,
  LabelList,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from "recharts";
import { ConferenceNotSelected } from "../_components/ConferenceNotSelected";
import { confService } from "../_services";
import CustomBarChart from "./BarCharts";

//const colors = ["#82ca9d", "#f4a582", "#b39ddb", "#ffee58", "#80deea"];
const colors = [
  "#82ca9d",
  "#f42582",
  "#b39ddb",
  "#eeaa58",
  "#80deea",
  "#ff8a65",
  "#ba68c8",
  "#4db6ac",
  "#7986cb",
  "#f06292",
];

class StatPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      dataByHours: [],
      daysList: [],
      conferenceId: 0,
    };
  }

  getStatistics = conferenceId => {
    if (!conferenceId || conferenceId === '0') {
      this.setState({
        daysList: [],
        dataByHours: [],
        conferenceId: 0
      });
      return;
    };

    const self = this;
    this.setState({ isLoading: true });

    confService.getStatsParticipByDays(
      conferenceId,
      (data) => {
        console.log(data);

        self.setState({
          daysList: [...data.data.days].filter((item, index) => index < 10),
          dataByHours: [...data.data.graph],
          isLoading: false,
          conferenceId: (conferenceId && conferenceId !== '0') ? conferenceId : 0
        });
      },
      (error) => {
        console.log(error);
        self.setState({ isLoading: false });
      }
    );
  };

  render() {
    const { isLoading, dataByHours, daysList } = this.state;

    console.log(dataByHours, daysList);

    return (
      <div className="layout">
        <div className="layout__contains">
          <h1 className="layout__title">{i18next.t("statistics")}</h1>
        </div>

        <ConferenceNotSelected page={"statistics"} onChange={conferenceId => this.getStatistics(conferenceId)} isGlobalSelector={false} />

        {/* Пустой график рисовал пунктирную сетку со сдвигом под ось Y —
            на телефоне выглядело как рамка, уехавшая вправо (пункт 77
            QA-таблицы). Без данных графика нет вовсе. */}
          {dataByHours.length > 0 && (
          <ResponsiveContainer
            width={"100%"}
            height={800}
            style={{ marginTop: 10 }}
          >
            <LineChart
              data={dataByHours}
              margin={{
                top: 5,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />

              {daysList.map((item, index) => (
                <Line
                  type="monotone"
                  dataKey={item}
                  stroke={colors[index % 10]}
                >
                  <LabelList
                    dataKey={item}
                    position="top"
                    offset={10}
                    fill="#8884d8"
                    fontSize={12}
                  />
                </Line>
              ))}
            </LineChart>
          </ResponsiveContainer>
          )}

        {isLoading && (
          <div className="shadow">
            <div className="shadow_circle">
              <CircularProgress />
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { app, user, authentication } = state;

  return {
    user,
    app,
    authentication,
  };
}

const connectedStatPage = connect(mapStateToProps)(StatPage);
export { connectedStatPage as StatPage };
